import { render } from "./basic-input.vue?vue&type=template&id=62497f74"
import script from "./basic-input.vue?vue&type=script&lang=js"
export * from "./basic-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__